import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-sponsors',
    templateUrl: './footer-sponsors.component.html',
    styleUrl: './footer-sponsors.component.scss',
    standalone: true
})
export class FooterSponsorsComponent {

}
